// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbWrap":"Breadcrumb_breadcrumbWrap__2vxW4 container mw-100 w-100","breadcrumbLink":"Breadcrumb_breadcrumbLink__ARop0"};